module.exports = __webpack_public_path__ + "4e09-Badge-1.png";